import { getPaginationSettings, IPaginationSettings } from 'wisestep-api';
import create from 'zustand';

export interface IPaginationSettingsStore {
  setPaginationSettings: () => void;
  getPaginationSettings: () => IPaginationSettings;
}

export const paginationSettingsStore = create<IPaginationSettingsStore>(() => ({
  setPaginationSettings: () => setPaginationSettingsData(),
  getPaginationSettings: () => getPaginationSettingsData(),
}));

const setPaginationSettingsData = async () => {
  if (window.localStorage.getItem('paginationSettings')) return;
  const paginationContext = await getPaginationSettings();
  const context = paginationContext.data;
  window.localStorage.setItem('paginationSettings', JSON.stringify(context));
};

const getPaginationSettingsData = (): IPaginationSettings => {
  const paginationSettings = window.localStorage.getItem('paginationSettings');
  const data: IPaginationSettings = JSON.parse(paginationSettings ?? '{}');
  return data;
};
